import { useState, useEffect } from 'react';

const DEFAULT_LIMIT = 20;
const timeoutIds = /* @__PURE__ */ new WeakMap();
const simpleDebounce = (fn, delay) => (...args) => {
  clearTimeout(timeoutIds.get(fn));
  const timeoutId = setTimeout(() => {
    fn(...args);
  }, delay);
  timeoutIds.set(fn, timeoutId);
};
const dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, " ").trim();
const useAppSearchData = ({ limit, searchDebounceDelay, excludeUpcoming, includeIsAppAdmin, includeIsAppCollaborator, apiHostname, onResultsUpdate }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const searchQueryTrimmed = dedupeAndTrimWhitespace(searchQuery);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (searchQueryTrimmed === "") {
      setData([]);
      return;
    }
    async function fetchAppData() {
      const searchParams = new URLSearchParams();
      searchParams.append("limit", (limit || DEFAULT_LIMIT).toString());
      searchParams.append("title_search", searchQueryTrimmed);
      if (excludeUpcoming)
        searchParams.append("exclude_upcoming", excludeUpcoming.toString());
      if (includeIsAppAdmin)
        searchParams.append("including_is_app_admin", includeIsAppAdmin.toString());
      if (includeIsAppCollaborator)
        searchParams.append("including_is_app_collaborator", includeIsAppCollaborator.toString());
      try {
        setLoading(true);
        const response = await fetch(`${apiHostname}/api/v4/apps?${searchParams.toString()}`);
        if (!response.ok) {
          throw new Error("Response was not OK");
        }
        const preTransformedAppsResponse = await response.json();
        const edges = preTransformedAppsResponse.results.map((app) => {
          return {
            id: app.id,
            canonicalId: app.canonical_id,
            slug: app.slug,
            name: app.name,
            currentImplementation: {
              id: app.current_implementation_id
            },
            images: app.images
          };
        });
        setData(edges);
        if (onResultsUpdate) {
          onResultsUpdate(searchQuery, edges);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    fetchAppData();
  }, [
    excludeUpcoming,
    includeIsAppAdmin,
    includeIsAppCollaborator,
    limit,
    searchQueryTrimmed
  ]);
  return {
    loading,
    onSearch: simpleDebounce((query) => {
      setSearchQuery(dedupeAndTrimWhitespace(query));
    }, searchDebounceDelay || 0),
    searchQuery: dedupeAndTrimWhitespace(searchQuery),
    apps: data
  };
};

export { useAppSearchData };
//# sourceMappingURL=useAppSearchData.es.js.map
